const CODE_FIELDS = ["code", "description", "laterality", "encounter", "approach", "body_system", "category"];
const AIS_FIELDS = ["ais2015_code", "ais2015_description", "ais_severity", "ais_region"];

const pick = (obj, fields) =>
  Object.fromEntries(fields.filter((f) => obj?.[f] !== undefined).map((f) => [f, obj[f]]));

const aisSeverity = (code) => {
  const m = /\.(\d)\b/.exec(code || "");
  return m ? Number(m[1]) : null;
};

export function toggleCodeOverride(item, group, draft) {
  if (item.overridden) return { ...item, ...item.auditor, overridden: false, auditor: null };
  const orig = (draft?.[group] || []).find((d) => d.code === item.corrected_from) || {};
  return {
    ...item,
    ...pick(orig, CODE_FIELDS),
    code: item.corrected_from,
    overridden: true,
    auditor: pick(item, CODE_FIELDS),
  };
}

export function toggleAisOverride(item, draft) {
  if (item.ais_overridden) return { ...item, ...item.ais_auditor, ais_overridden: false, ais_auditor: null };
  const orig = (draft?.injuries || []).find((d) => d.ais2015_code === item.ais_corrected_from) || {};
  return {
    ...item,
    ...pick(orig, AIS_FIELDS),
    ais2015_code: item.ais_corrected_from,
    ais_severity: aisSeverity(item.ais_corrected_from) || item.ais_severity,
    ais_overridden: true,
    ais_auditor: pick(item, AIS_FIELDS),
  };
}
